// Sprint 9.8 — Palette tags alignée FABRIK (soft tones + 4 pastels chauds).
// Réutilise le même set que les avatars (--avatar-0..9) pour cohérence.
export const colors = [
  "#f5d3a4", // peach
  "#c9e7d8", // mint
  "#cfe0f8", // sky
  "#ddd2f4", // lavender
  "#f6cfd6", // pink
  "#f4e6c1", // cream
  "#e3f4ec", // fabrik green soft
  "#fbeed8", // fabrik orange soft
  "#e2ebfa", // fabrik blue soft
  "#ede8fa", // fabrik purple soft
];
